import React, {ReactNode, useEffect, useState} from "react";
import { AppContextProvider } from '../provider/AppContextProvider';

import ConsentManager from './ConsentManager'
import ConsentManagerIOS from './ConsentManagerIOS'

import MainContent from './MainContent'
import { DeviceFontScaleGate } from './DeviceFontScaleGate'

//import FacebookPixel from '../components/FacebookPixel';

import {Router, useRouter} from "next/router";
import { ConsentContextProvider } from "../provider/ConsentContextProvider";
import { CacheContextProvider } from "../provider/CacheContextProvider";

type AppWrapperProps = {
  children: ReactNode
}

function AppWrapper({ children }: AppWrapperProps) {
  const router = useRouter();
  const [enableCMP, setEnableCMP] = useState(false)
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    if (window.startInAppPurchase instanceof Function){
      setIsIOS(true)
    }
    if (!router.asPath.startsWith("/navigation") && !router.asPath.startsWith("/user")){
      setEnableCMP(true)
    }
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AppContextProvider>
      <DeviceFontScaleGate />
      <CacheContextProvider>
        <ConsentContextProvider>
          {enableCMP && !isIOS && <ConsentManager />}
          {enableCMP && isIOS && <ConsentManagerIOS />}
          <React.Fragment>
            <MainContent>
              {children}
            </MainContent>
          </React.Fragment>
        </ConsentContextProvider>

        {/* <FacebookPixel /> */}
        {/* <div className={ getCss() }> */}
      </CacheContextProvider>
    </AppContextProvider>
  );
}

export default AppWrapper;
